// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"sidebar_3nfAf"};


//////////////////
// WEBPACK FOOTER
// ./app/components/sidebar/styles.scss
// module id = 503
// module chunks = 1